export default "__VITE_ASSET__Yx02cYj9__"